var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_514_146577",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_514_146577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 8C6.625 8 7.15633 7.78133 7.594 7.344C8.03133 6.90633 8.25 6.375 8.25 5.75C8.25 5.125 8.03133 4.59367 7.594 4.156C7.15633 3.71867 6.625 3.5 6 3.5C5.375 3.5 4.84367 3.71867 4.406 4.156C3.96867 4.59367 3.75 5.125 3.75 5.75C3.75 6.375 3.96867 6.90633 4.406 7.344C4.84367 7.78133 5.375 8 6 8ZM6 7.1C5.625 7.1 5.30633 6.96867 5.044 6.706C4.78133 6.44367 4.65 6.125 4.65 5.75C4.65 5.375 4.78133 5.05617 5.044 4.7935C5.30633 4.53117 5.625 4.4 6 4.4C6.375 4.4 6.69383 4.53117 6.9565 4.7935C7.21883 5.05617 7.35 5.375 7.35 5.75C7.35 6.125 7.21883 6.44367 6.9565 6.706C6.69383 6.96867 6.375 7.1 6 7.1ZM6 9.5C4.78333 9.5 3.675 9.16033 2.675 8.481C1.675 7.802 0.95 6.89167 0.5 5.75C0.95 4.60833 1.675 3.69783 2.675 3.0185C3.675 2.3395 4.78333 2 6 2C7.21667 2 8.325 2.3395 9.325 3.0185C10.325 3.69783 11.05 4.60833 11.5 5.75C11.05 6.89167 10.325 7.802 9.325 8.481C8.325 9.16033 7.21667 9.5 6 9.5ZM6 8.5C6.94167 8.5 7.80633 8.252 8.594 7.756C9.38133 7.26033 9.98333 6.59167 10.4 5.75C9.98333 4.90833 9.38133 4.2395 8.594 3.7435C7.80633 3.24783 6.94167 3 6 3C5.05833 3 4.19367 3.24783 3.406 3.7435C2.61867 4.2395 2.01667 4.90833 1.6 5.75C2.01667 6.59167 2.61867 7.26033 3.406 7.756C4.19367 8.252 5.05833 8.5 6 8.5Z",
    fill: "#F6F6F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.cf24801664b3e4f86e9753b907f35c47.svg";
export { ForwardRef as ReactComponent };